import * as cons from './constants';
import { isNonNull, isNumber, isObject } from './helper';
import styles from '@dtsl/css-grid/dist/index.module.css';
export const getColumnClasses = (span, start, end, offset) => {
  const columnClasses = [];
  columnClasses.push(...getBreakpointClassNames(span, cons.COL_DEF_PARAMS.SPAN));
  columnClasses.push(...getBreakpointClassNames(start, cons.COL_DEF_PARAMS.START));
  columnClasses.push(...getBreakpointClassNames(end, cons.COL_DEF_PARAMS.END));
  if (isNumber(offset) && offset > 0) {
    columnClasses.push(...getBreakpointClassNames(offset + 1, cons.COL_DEF_PARAMS.START));
  }
  if (isObject(offset) && isNonNull(offset)) {
    let startGridLines = {};
    for (let key in offset) {
      if (isNumber(offset[key]) && offset[key] > 0) {
        startGridLines[key] = offset[key] + 1;
      }
    }
    columnClasses.push(...getBreakpointClassNames(startGridLines, cons.COL_DEF_PARAMS.START));
  }
  return columnClasses.join(' ');
};
export const getBreakpointClassNames = (colParam, colParamName) => {
  let resultClasses = [];
  if (isNumber(colParam)) {
    const colParamClassPrefix = `COL_${colParamName?.toUpperCase()}_PREFIX_CMN`;
    const className = concatenateClass(null, cons[colParamClassPrefix], colParam);
    if (className) resultClasses.push(styles[className]); // modularised class name
  }
  if (isObject(colParam) && isNonNull(colParam)) {
    // responsive value
    const colParamClassPrefix = `COL_${colParamName?.toUpperCase()}_PREFIX`;
    Object.keys(cons.BREAKPOINTS).forEach(breakpoint => {
      const val = colParam[breakpoint];
      if (isNumber(val)) {
        const className = concatenateClass(breakpoint, cons[colParamClassPrefix], val);
        if (className) resultClasses.push(styles[className]); // modularised class name
      }
    });
  }
  return resultClasses;
};
export const concatenateClass = (breakpoint, prefix, value) => breakpoint ? getBreakpointPrefixClass(breakpoint) + prefix + value : prefix + value;
export const getBreakpointPrefixClass = function () {
  let breakpoint = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'S';
  // 'naos-gcol--S:' OR naos-gcol--M: OR naos-gcol--L:
  return `${cons.COL_BREAKPOINT_PREFIX}${breakpoint}:`;
};